import React, { useState, useEffect, useMemo, useRef } from "react";
import "./ReviewPayrollBatch.scss";
import {
  ScheduleJobList4,
  updateBatchStatus,
  ListTransFileRecs,
  UpdateTransFileRecs,
  DeleteTransFileRecs,
  sendEmail2,
  GetMerchantProfile,
} from "../../util/API/batch";
import {
  CircularProgress,
  Box,
  Button,
  Modal,
  TextField,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import { useSelector } from "react-redux";
import PinPad from "../PinPad/PinPad";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { decodeHtmlEntities } from "../../util/utilfunctions/utilFunctions";
import { getUserDetails } from "../../util/API/customers";
const PAYROLL_CATEGORY_ID = "33";
const INCORRECT_PIN_ERROR = "INCORRECT_PIN";

const STATUS_OPTIONS = [
  "Open",
  "Review",
  "Approved for Processing",
  "Rejected",
  "Completed",
  "Error",
  "Cancelled",
];

const STATUS_TO_CODE = {
  Open: "-2",
  "Review in Progress": "-1",
  "Approved for Processing": "1",
  "Approved for Processing": "0",
  Rejected: "5",
  Completed: "3",
  Error: "2",
  Cancelled: "4",
};

const getDisplayStatus = (code) => {
  const map = {
    "-2": "Open",
    "-1": "Review in Progress",
    1: "Approved for Processing",
    0: "Approved for Processing",

    5: "Rejected",
    3: "Completed",
    2: "Error",
    4: "Cancelled",
  };
  return map[code] || `Unknown (${code})`;
};

export default function ReviewPayrollBatch() {
  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingIds, setSavingIds] = useState(new Set());
  const [showPinPad, setShowPinPad] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [pendingRecordSave, setPendingRecordSave] = useState(false);
  const [userNames, setUserNames] = useState({});
const [cancelSnackbar, setCancelSnackbar] = useState({ open: false, message: "" });
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "success",
    header: "Success",
  });

  // Record editing state
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [records, setRecords] = useState([]);
  const [recordsLoading, setRecordsLoading] = useState(false);
  const [editingRecId, setEditingRecId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [pendingDeletePin, setPendingDeletePin] = useState("");

  // NEW STATES FOR SCHEDULED TIME EDITING
  const [editingScheduledId, setEditingScheduledId] = useState(null);
  const [tempScheduledValue, setTempScheduledValue] = useState("");
  const [pendingScheduledChange, setPendingScheduledChange] = useState(null);
  const isSubmittingRef = useRef(false);
  const [pinProcessing, setPinProcessing] = useState(false);

  // ── DELETE ROW STATE ──────────────────────────────────────────────────────
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [pendingDeleteRec, setPendingDeleteRec] = useState(null); // record to delete
  const [deletingRecIds, setDeletingRecIds] = useState(new Set()); // spinner per row
  // ─────────────────────────────────────────────────────────────────────────

  const merchantInfo = useSelector((state) => state.login.user);
  const currentUserId = merchantInfo?.id;
  const currentUsername =
    `${merchantInfo?.firstName || ""} ${merchantInfo?.lastName || ""}`.trim() ||
    "Payroll Admin";
  const curruserdetails = JSON.parse(sessionStorage.getItem("user"));
  const currCompanyName = curruserdetails?.payload?.body?.User?.otherNames;
  const getUserName = async (userid) => {
    if (!userid || userNames[userid]) return;
    try {
      const response = await getUserDetails(userid);
      const raw = response?.User || response;
      const fullName =
        `${cleanName(raw?.firstName || "")} ${cleanName(raw?.lastName || "")}`.trim();
      setUserNames((prev) => ({ ...prev, [userid]: fullName || userid }));
    } catch {
      setUserNames((prev) => ({ ...prev, [userid]: userid }));
    }
  };

  const configVariables = useSelector((state) => state.config.baseConfig);
  const isDevEnv = configVariables?.devEnvironment;

  const emailRec = isDevEnv
    ? "no-reply@4pay.ca"
    : "kayon.stokes@ncsenterprises.com";

  console.log("emailrec0", emailRec);

  // NEW: Fetch company name via GetMerchantProfile
  const [companyName, setCompanyName] = useState("Unknown Company");

  useEffect(() => {
    const fetchCompanyName = async () => {
      if (currentUserId) {
        try {
          const res = await GetMerchantProfile("", currentUserId);
          console.log(
            "GetMerchantProfile response:",
            JSON.stringify(res, null, 2),
          );

          if (res?.callStatus === "1") {
            const businessname =
              res.payload?.Merchant?.businessname || "Unknown Company";
            setCompanyName(
              businessname
                .replace(/&amp;amp;/g, "&")
                .replace(/&amp;#039;/g, "'")
                .replace(/&amp;#39;/g, "'")
                .replace(/&amp;/g, "&")
                .replace(/&quot;/g, '"')
                .replace(/&#34;/g, "'")
                .replace(/&#039;/g, "'")
                .replace(/&#39;/g, "'")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .trim(),
            );
          }
        } catch (err) {
          console.error("Failed to fetch merchant profile:", err);
        }
      }
    };

    fetchCompanyName();
  }, [currentUserId]);

  // Fetch names for ALL unique user IDs across all batches
  useEffect(() => {
    if (batches.length === 0) return;
    const uniqueIds = new Set();
    batches.forEach((b) => {
      if (b.uploadedby) uniqueIds.add(b.uploadedby);
      if (b.approvedby) uniqueIds.add(b.approvedby);
      if (b.rejectedby) uniqueIds.add(b.rejectedby);
    });
    uniqueIds.forEach((id) => getUserName(id));
  }, [batches]);
  const cleanName = (name) =>
    decodeHtmlEntities(decodeHtmlEntities(name || ""))
      .replace(/[^a-zA-Z0-9\s'&.-]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  const normalizeName = (name) => {
  if (!name) return "";

  // 1. Decode HTML entities (up to 3 passes for triple-encoded strings)
  let decoded = name;
  for (let i = 0; i < 3; i++) {
    const prev = decoded;
    const txt = document.createElement("textarea");
    txt.innerHTML = prev;
    decoded = txt.value;
    if (decoded === prev) break;
  }

  return decoded
    .replace(/&amp;/g, "&")       // catch any remaining literal &amp;
    .replace(/[|]/g, " ")         // normalize pipe to space (common in company names)
    .replace(/[^a-zA-Z0-9\s'&.-]/g, "") // strip special chars
    .replace(/[\u00A0\u200B\u FEFF]/g, " ") // replace non-breaking/zero-width spaces
    .replace(/\s+/g, " ")         // collapse whitespace
    .trim()
    .toLowerCase();               // case-insensitive comparison
};
  const cleanComment = (text) =>
    text
      ? text
          .replace(/&amp;amp;/g, "&")
          .replace(/&amp;#039;/g, "'")
          .replace(/&amp;#39;/g, "'")

          .replace(/&amp;/g, "&")
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
          .replace(/&lt;/g, "<")
          .replace(/&gt;/g, ">")
          .replace(/&nbsp;/g, " ")
          .split("\n")
          .filter(Boolean)
          .join(" • ")
      : "—";
  const cleanFileName = (fileName) => {
    if (!fileName) return "—";

    return fileName
      .replace(/&amp;#039;/g, "'")
      .replace(/&#039;/g, "'")
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, "&")
      .replace(/&/g, "_and_")
      .replace(/[()]/g, "")
      .replace(/[^a-zA-Z0-9\s'_.-]/g, "")
      .replace(/\s+/g, "_")
      .replace(/_+/g, "_")
      .trim();
  };
  // ====================== TOTAL AMOUNT CALCULATION ======================
  const totalsByCurrency = useMemo(() => {
    const totals = {};

    records.forEach((rec) => {
      let amount = parseFloat(rec.amount) || 0;
      let currency = rec.currency || "CAD";

      // Use live edit values if this record is being edited
      if (rec.id === editingRecId) {
        amount = parseFloat(editForm.amount) || 0;
        currency = editForm.currency || "CAD";
      }

      if (!totals[currency]) totals[currency] = 0;
      totals[currency] += amount;
    });

    return totals;
  }, [records, editingRecId, editForm.amount, editForm.currency]);

  const grandTotal = Object.values(totalsByCurrency).reduce(
    (sum, val) => sum + val,
    0,
  );
  const currencyList = Object.keys(totalsByCurrency);
  const isSingleCurrency = currencyList.length === 1;
  const mainCurrency = isSingleCurrency ? currencyList[0] : null;
  // =====================================================================

  const fetchAllPayrollBatches = async () => {
    setLoading(true);
    try {
      const response = await ScheduleJobList4({
        categoryid: PAYROLL_CATEGORY_ID,
        rows: 1000,
      });

      if (response.callStatus === "1") {
        let raw = response.payload?.record || [];
        if (!Array.isArray(raw)) raw = raw ? [raw] : [];

        const mapped = raw.map((item) => {
          const s = item.Scheduleinstance;
          const recordsMatch = s.notes?.match(/records:\s*(\d+)/i);
          const totalRecords = recordsMatch ? parseInt(recordsMatch[1], 10) : 0;

          const cleanNotes = s.notes
            ? decodeHtmlEntities(s.notes)
                .replace(/&amp;amp;/g, "&")
                .replace(/&amp;#039;/g, "'")
                .replace(/&amp;#39;/g, "'")

                .replace(/&amp;/g, "&")
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, "'")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&nbsp;/g, " ")
                .split("\n")
                .filter(Boolean)
                .join(" • ")
            : "—";
          const isCancelled = String(s.executionstatus) === "4";
          const rawAmount = parseFloat(s.amount) || 0;

          const finalAmount =
            isCancelled && totalRecords === 0
              ? 0 //  ONLY override when BOTH true
              : rawAmount;

          return {
            id: s.requestid,
            agentId: s.requestuserid,
            fileName: s.inputfilename,
            companyName: s.companyname || "-",
            records: totalRecords,
            uploadedAt: s.requesttime || s.scheduletime || "—",
            notes: cleanNotes,
            status: getDisplayStatus(s.executionstatus),
            rawStatus: s.executionstatus,
            requestuserid: s.requestuserid,
            uploadedby: s.uploadedby === "0" ? null : s.uploadedby,
            approvedby:
              String(s.executionstatus) === "5"
                ? null
                : s.approvedby === "0"
                  ? null
                  : s.approvedby,
            rejectedby:
              String(s.executionstatus) === "5"
                ? s.approvedby === "0"
                  ? null
                  : s.approvedby
                : null,
            totalAmount: finalAmount,

            totalAmountDisplay: finalAmount.toLocaleString("en-US", {
              minimumFractionDigits: 2,
            }),

            scheduledTime: s.scheduletime || "—",
          };
        });

        const filtered = mapped.filter(
          (batch) => normalizeName(batch.companyName) === normalizeName(companyName),
        );
        const statusWiseFilters = filtered.filter(
          (batch) =>
            batch.rawStatus === "-2" ||
            batch.rawStatus === "-1" ||
            batch.rawStatus === "5" ||
            batch.rawStatus === "4",
        );
        setBatches(statusWiseFilters);
      } else {
        setBatches([]);
      }
    } catch (err) {
      console.error("Failed to load batches:", err);
      setBatches([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (companyName && companyName !== "Unknown Company") {
      fetchAllPayrollBatches();
    }
  }, [companyName]);

  const refreshBatches = async () => {
    setLoading(true);
    await fetchAllPayrollBatches();
    setLoading(false);
  };

  const openRecordEditor = async (batch) => {
    setSelectedBatch(batch);
    setRecords([]);
    setEditingRecId(null);
    setRecordsLoading(true);

    try {
      // const res = await ListTransFileRecs(batch.id);

      // if (res.callStatus !== "1") {
      //   setAlert({
      //     open: true,
      //     severity: "error",
      //     header: "Access Denied",
      //     message: "Cannot load records for this batch."
      //   });
      //   setRecordsLoading(false);
      //   return;
      // }

      // const raw = res.payload?.record || [];
      // const rawArray = Array.isArray(raw) ? raw : [raw];

      // if (rawArray.length === 0) {
      //   setAlert({
      //     open: true,
      //     severity: "info",
      //     header: "Empty Batch",
      //     message: "No records found in this batch."
      //   });
      //   setRecords([]);
      //   setRecordsLoading(false);
      //   return;
      // }
      // REPLACE WITH this:
      const res = await ListTransFileRecs(batch.id);

      const raw = res.payload?.record || null;
      const rawArray = !raw ? [] : Array.isArray(raw) ? raw : [raw];

      // // Empty batch: API may return callStatus !== "1" OR an empty payload — both mean no records
      // if (res.callStatus !== "1" || rawArray.length === 0) {
      //   const isRealError =
      //     res.callStatus !== "1" &&
      //     rawArray.length === 0 &&
      //     res.payload?.msg &&
      //     !res.payload.msg.toLowerCase().includes("no record") &&
      //     !res.payload.msg.toLowerCase().includes("not found") &&
      //     !res.payload.msg.toLowerCase().includes("empty");

      //   setAlert({
      //     open: true,
      //     severity: isRealError ? "error" : "info",
      //     header: isRealError ? "Failed to Load" : "No Records Found",
      //     message: isRealError
      //       ? res.payload?.msg || "Could not load records for this batch."
      //       : "This batch has no records yet.",
      //   });
      //   setRecords([]);
      //   setRecordsLoading(false);
      //   return;
      // }
      // Empty batch: API may return callStatus !== "1" OR an empty payload
      if (res.callStatus !== "1" || rawArray.length === 0) {
        const isRealError =
          res.callStatus !== "1" &&
          rawArray.length === 0 &&
          res.payload?.msg &&
          !res.payload.msg.toLowerCase().includes("no record") &&
          !res.payload.msg.toLowerCase().includes("not found") &&
          !res.payload.msg.toLowerCase().includes("empty");

        if (isRealError) {
          // Genuine API error — don't open modal, show alert
          setAlert({
            open: true,
            severity: "error",
            header: "Failed to Load",
            message:
              res.payload?.msg || "Could not load records for this batch.",
          });
          setSelectedBatch(null); // <-- prevent modal from opening
        } else {
          // Empty batch — let the modal open but show empty state inline
          setRecords([]); // modal will render "No records found in this batch."
        }
        setRecordsLoading(false);
        return;
      }
      const allRecords = rawArray
        .map((item) => item.Transfilerecs)
        .filter(Boolean);

      if (allRecords.length === 0) {
        setAlert({
          open: true,
          severity: "warning",
          header: "No Data",
          message: "Records exist but structure is empty.",
        });
        setRecords([]);
        setRecordsLoading(false);
        return;
      }

      const mapped = allRecords.map((r) => ({
        id: r.recid,
        recid: r.recid,
        requestid: r.requestid,
        // Backend values can be HTML-encoded (for example, John&amp;#039;s).
        // Decode them before populating the review/edit form.
        firstname: decodeHtmlEntities(r.firstname?.trim() || ""),
        lastname: decodeHtmlEntities(r.lastname?.trim() || ""),
        email: r.email?.trim() || "",
        amount: r.amount || "",
        currency: r.currency || "",
        phoneno: r.phoneno || "",
        address1: r.address1 || "",
        address2: r.address2 || "",
        country: r.country || "",
        state: r.state || "",
        zipcode: r.zipcode || "",
        birthdate: r.birthdate === "0000-00-00" ? "" : r.birthdate,
        accountno: String(r.accountno ?? "0"),
        comment: decodeHtmlEntities(r.comment) || "",
        purposeofaccount: r.purposeofaccount || "",
        status: r.status === "0" ? "Pending" : r.status || "Pending",
        errormessage: r.errormessage || "",
      }));

      setRecords(mapped);
      console.log(`Loaded ${mapped.length} records successfully!`, mapped);
      setRecordsLoading(false);
    } catch (err) {
      console.error("Failed to load records:", err);
      setAlert({
        open: true,
        severity: "error",
        header: "Load Failed",
        message: "Error loading batch records.",
      });
      setRecordsLoading(false);
    }
  };

  // const startEdit = (record) => {
  //   setEditingRecId(record.id);
  //   setEditForm({
  //     ...record,
  //     comment:
  //       cleanComment(record.comment) === "—"
  //         ? ""
  //         : cleanComment(record.comment),
  //   });
  // };
  const startEdit = (record) => {
  setEditingRecId(record.id);
  setEditForm({
    ...record,
    comment:
      cleanComment(record.comment) === "—" ? "" : cleanComment(record.comment),
    addressCombined: `${record.address1 || ""}${record.address2 ? " " + record.address2 : ""}`,
  });
};
  // const saveRecord = async () => {
  //   const statusCodeMap = { Pending: "0", CORRECTED: "1", ERROR: "2" };

  //   const payloadToSend = {
  //     ...editForm,
  //     status: statusCodeMap[editForm.status] || editForm.status || "0",
  //   };

  //   const updatedRecords = records.map((r) =>
  //     r.recid === editForm.recid ? { ...editForm } : r,
  //   );
  //   const newTotal = updatedRecords.reduce(
  //     (sum, r) => sum + (parseFloat(r.amount) || 0),
  //     0,
  //   );
  //   const amountChanged = newTotal !== selectedBatch?.totalAmount;

  //   if (amountChanged) {
  //     setPendingRecordSave({ payloadToSend, updatedRecords, newTotal });
  //     setShowPinPad(true);
  //   } else {
  //     try {
  //       const result = await UpdateTransFileRecs(payloadToSend);
  //       if (result.callStatus === "1") {
  //         setRecords(updatedRecords);
  //         setEditingRecId(null);
  //         setAlert({
  //           open: true,
  //           severity: "success",
  //           header: "Saved!",
  //           message: "Record updated successfully.",
  //         });
  //       } else {
  //         throw new Error();
  //       }
  //     } catch (err) {
  //       setAlert({
  //         open: true,
  //         severity: "error",
  //         header: "Save Failed",
  //         message: "Could not update record.",
  //       });
  //     }
  //   }
  // };

  // ── DELETE ROW HANDLERS ───────────────────────────────────────────────────
  /**
   * Opens the confirmation dialog before deleting a record.
   * Cancel button in the dialog calls setDeleteConfirmOpen(false).
   */
  const saveRecord = async () => {
  const statusCodeMap = { Pending: "0", CORRECTED: "1", ERROR: "2" };

  // Split the combined address only now, on save — not on every keystroke.
  const addressParts = (editForm.addressCombined || "").split(" ");
  const address1 = addressParts.slice(0, 8).join(" ");
  const address2 = addressParts.slice(8).join(" ");
  const finalEditForm = { ...editForm, address1, address2 };

  const payloadToSend = {
    ...finalEditForm,
    status: statusCodeMap[finalEditForm.status] || finalEditForm.status || "0",
  };

  const updatedRecords = records.map((r) =>
    r.recid === finalEditForm.recid ? { ...finalEditForm } : r,
  );
  const newTotal = updatedRecords.reduce(
    (sum, r) => sum + (parseFloat(r.amount) || 0),
    0,
  );
  const amountChanged = newTotal !== selectedBatch?.totalAmount;

  if (amountChanged) {
    setPendingRecordSave({ payloadToSend, updatedRecords, newTotal });
    setShowPinPad(true);
  } else {
    try {
      const result = await UpdateTransFileRecs(payloadToSend);
      if (result.callStatus === "1") {
        setRecords(updatedRecords);
        setEditingRecId(null);
        setAlert({
          open: true,
          severity: "success",
          header: "Saved!",
          message: "Record updated successfully.",
        });
      } else {
        throw new Error();
      }
    } catch (err) {
      setAlert({
        open: true,
        severity: "error",
        header: "Save Failed",
        message: "Could not update record.",
      });
    }
  }
};
  const promptDeleteRecord = (record) => {
    console.log("record------====================", record);
    setPendingDeleteRec(record);
    setDeleteConfirmOpen(true);
  };

  /**
   * Confirmed delete: calls DeleteTransFileRecs, then syncs batch total via
   * updateBatchStatus so the server-side amount stays accurate.
   */
  // // const confirmDeleteRecord = async () => {
  // //   if (!pendingDeleteRec) return;

  // //   const rec = pendingDeleteRec;
  // //   setDeleteConfirmOpen(false);
  // //   setPendingDeleteRec(null);

  // //   // Optimistically add spinner for this row
  // //   setDeletingRecIds((prev) => new Set([...prev, rec.recid]));

  // //   try {
  // //     const result = await DeleteTransFileRecs({ recId: rec.recid });

  // //     if (result?.data?.header?.callStatus !== "1") {
  // //       throw new Error(result?.payload?.msg || "Delete failed");
  // //     }

  // //     // Remove record from local state
  // //     const updatedRecords = records.filter((r) => r.recid !== rec.recid);
  // //     setRecords(updatedRecords);

  // //     // Recalculate total and sync to batch
  // //     const newTotal = updatedRecords.reduce(
  // //       (sum, r) => sum + (parseFloat(r.amount) || 0),
  // //       0,
  // //     );
  // //     const updatedCount = updatedRecords.length;
  // //     const updatedNotes = selectedBatch.notes
  // //       ? selectedBatch.notes.replace(
  // //           /records:\s*\d+/i,
  // //           `records: ${updatedCount}`,
  // //         )
  // //       : selectedBatch.notes;

  // //     // Sync updated total to the batch header (best-effort, non-blocking)
  // //     try {
  // //       await updateBatchStatus({
  // //         requestid: selectedBatch.id,
  // //         executionstatus: selectedBatch.rawStatus,
  // //         notes: updatedNotes || "",
  // //         pin: "", // no PIN required — amount change triggered by delete, not edit
  // //         requestuserid: currentUserId,
  // //         amount: newTotal,
  // //         uploadedby: selectedBatch.agentId,
  // //         approvedby: 0,
  // //         lastuserid: currentUserId,
  // //         scheduletime:
  // //           selectedBatch.scheduledTime !== "—"
  // //             ? selectedBatch.scheduledTime
  // //             : undefined,
  // //       });
  // //       // const updatedCount = updatedRecords.length;

  // //       // setBatches((prev) =>
  // //       //   prev.map((b) =>
  // //       //     b.id === selectedBatch.id
  // //       //       ? {
  // //       //           ...b,
  // //       //           totalAmount: newTotal,
  // //       //           totalAmountDisplay: newTotal.toLocaleString("en-US", {
  // //       //             minimumFractionDigits: 2,
  // //       //           }),
  // //       //           records: updatedCount,
  // //       //           notes: b.notes
  // //       //             ? b.notes.replace(
  // //       //                 /records:\s*\d+/i,
  // //       //                 `records: ${updatedCount}`,
  // //       //               )
  // //       //             : b.notes,
  // //       //         }
  // //       //       : b,
  // //       //   ),
  // //       // );
  // //       // setSelectedBatch((prev) => ({
  // //       //   ...prev,
  // //       //   totalAmount: newTotal,
  // //       //   records: updatedCount,
  // //       // }));
  // //       setBatches((prev) =>
  // //         prev.map((b) =>
  // //           b.id === selectedBatch.id
  // //             ? {
  // //                 ...b,
  // //                 totalAmount: newTotal,
  // //                 totalAmountDisplay: newTotal.toLocaleString("en-US", {
  // //                   minimumFractionDigits: 2,
  // //                 }),
  // //                 records: updatedCount,
  // //                 notes: updatedNotes || b.notes, // ← use same updatedNotes variable
  // //               }
  // //             : b,
  // //         ),
  // //       );
  // //       setSelectedBatch((prev) => ({
  // //         ...prev,
  // //         totalAmount: newTotal,
  // //         records: updatedCount,
  // //         notes: updatedNotes || prev.notes, // ← keep selectedBatch in sync too
  // //       }));
  // //     } catch (syncErr) {
  // //       // Non-fatal: record is deleted, but total sync failed
  // //       console.warn(
  // //         "Batch total sync after delete failed (non-fatal):",
  // //         syncErr,
  // //       );
  // //     }

  // //     setAlert({
  // //       open: true,
  // //       severity: "success",
  // //       header: "Record Deleted",
  // //       message: `${rec.firstname} ${rec.lastname}'s record has been removed from the batch.`,
  // //     });
  // //   } catch (err) {
  // //     console.error("Delete record failed:", err);
  // //     setAlert({
  // //       open: true,
  // //       severity: "error",
  // //       header: "Delete Failed",
  // //       message:
  // //         err.message || "Could not delete the record. Please try again.",
  // //     });
  // //   } finally {
  // //     setDeletingRecIds((prev) => {
  // //       const s = new Set(prev);
  // //       s.delete(rec.recid);
  // //       return s;
  // //     });
  // //   }
  // // };
  // // // ─────────────────────────────────────────────────────────────────────────
  // const confirmDeleteRecord = async () => {
  //   if (!pendingDeleteRec) return;

  //   const rec = pendingDeleteRec;
  //   setDeleteConfirmOpen(false);
  //   setPendingDeleteRec(null);
  //   setDeletingRecIds((prev) => new Set([...prev, rec.recid]));

  //   try {
  //     const result = await DeleteTransFileRecs({ recId: rec.recid });

  //     if (result?.data?.header?.callStatus !== "1") {
  //       throw new Error(result?.payload?.msg || "Delete failed");
  //     }

  //     const updatedRecords = records.filter((r) => r.recid !== rec.recid);
  //     setRecords(updatedRecords);

  //     const newTotal = updatedRecords.reduce(
  //       (sum, r) => sum + (parseFloat(r.amount) || 0),
  //       0,
  //     );
  //     const updatedCount = updatedRecords.length;
  //     const updatedNotes = selectedBatch.notes
  //       ? selectedBatch.notes.replace(
  //           /records:\s*\d+/i,
  //           `records: ${updatedCount}`,
  //         )
  //       : selectedBatch.notes;

  //     // Best-effort sync to backend (non-blocking)
  //     try {
  //       await updateBatchStatus({
  //         requestid: selectedBatch.id,
  //         executionstatus: selectedBatch.rawStatus,
  //         notes: updatedNotes || "",
  //         pin: "",
  //         requestuserid: currentUserId,
  //         amount: newTotal,
  //         uploadedby: selectedBatch.agentId,
  //         approvedby: 0,
  //         lastuserid: currentUserId,
  //         scheduletime:
  //           selectedBatch.scheduledTime !== "—"
  //             ? selectedBatch.scheduledTime
  //             : undefined,
  //       });
  //     } catch (syncErr) {
  //       console.warn("Batch total sync failed (non-fatal):", syncErr);
  //     }

  //     // ✅ THE FIX: Refresh from server, then immediately override with
  //     // locally-computed values since server may return stale data
  //     await refreshBatches();

  //     setBatches((prev) =>
  //       prev.map((b) =>
  //         b.id === selectedBatch.id
  //           ? {
  //               ...b,
  //               totalAmount: newTotal,
  //               totalAmountDisplay: newTotal.toLocaleString("en-US", {
  //                 minimumFractionDigits: 2,
  //               }),
  //               records: updatedCount,
  //               notes: updatedNotes || b.notes,
  //             }
  //           : b,
  //       ),
  //     );

  //     setSelectedBatch((prev) => ({
  //       ...prev,
  //       totalAmount: newTotal,
  //       records: updatedCount,
  //       notes: updatedNotes || prev.notes,
  //     }));

  //     setAlert({
  //       open: true,
  //       severity: "success",
  //       header: "Record Deleted",
  //       message: `${rec.firstname} ${rec.lastname}'s record has been removed.`,
  //     });
  //   } catch (err) {
  //     console.error("Delete record failed:", err);
  //     setAlert({
  //       open: true,
  //       severity: "error",
  //       header: "Delete Failed",
  //       message:
  //         err.message || "Could not delete the record. Please try again.",
  //     });
  //   } finally {
  //     setDeletingRecIds((prev) => {
  //       const s = new Set(prev);
  //       s.delete(rec.recid);
  //       return s;
  //     });
  //   }
  // };
  // const executeDelete = async (pin) => {
  //   const rec = pendingDeleteRec;
  //   setDeleteConfirmOpen(false);
  //   setPendingDeleteRec(null);
  //   setDeletingRecIds((prev) => new Set([...prev, rec.recid]));

  //   try {
  //     const result = await DeleteTransFileRecs({ recId: rec.recid });

  //     if (result?.data?.header?.callStatus !== "1") {
  //       throw new Error(result?.payload?.msg || "Delete failed");
  //     }

  //     const updatedRecords = records.filter((r) => r.recid !== rec.recid);
  //     setRecords(updatedRecords);

  //     const newTotal = updatedRecords.reduce(
  //       (sum, r) => sum + (parseFloat(r.amount) || 0),
  //       0,
  //     );
  //     const updatedCount = updatedRecords.length;
  //     const updatedNotes = selectedBatch.notes
  //       ? selectedBatch.notes.replace(
  //           /records:\s*\d+/i,
  //           `records: ${updatedCount}`,
  //         )
  //       : selectedBatch.notes;

  //     // Best-effort sync to backend (non-blocking)
  //     try {
  //       await updateBatchStatus({
  //         requestid: selectedBatch.id,
  //         executionstatus: selectedBatch.rawStatus,
  //         notes: updatedNotes || "",
  //         pin: pin,
  //         requestuserid: currentUserId,
  //         amount: newTotal,
  //         uploadedby: selectedBatch.agentId,
  //         approvedby: 0,
  //         lastuserid: currentUserId,
  //         scheduletime:
  //           selectedBatch.scheduledTime !== "—"
  //             ? selectedBatch.scheduledTime
  //             : undefined,
  //       });
  //     } catch (syncErr) {
  //       console.warn("Batch total sync failed (non-fatal):", syncErr);
  //     }

  //     // ✅ THE FIX: Refresh from server, then immediately override with
  //     // locally-computed values since server may return stale data
  //     await refreshBatches();

  //     setBatches((prev) =>
  //       prev.map((b) =>
  //         b.id === selectedBatch.id
  //           ? {
  //               ...b,
  //               totalAmount: newTotal,
  //               totalAmountDisplay: newTotal.toLocaleString("en-US", {
  //                 minimumFractionDigits: 2,
  //               }),
  //               records: updatedCount,
  //               notes: updatedNotes || b.notes,
  //             }
  //           : b,
  //       ),
  //     );

  //     setSelectedBatch((prev) => ({
  //       ...prev,
  //       totalAmount: newTotal,
  //       records: updatedCount,
  //       notes: updatedNotes || prev.notes,
  //     }));

  //     setAlert({
  //       open: true,
  //       severity: "success",
  //       header: "Record Deleted",
  //       message: `${rec.firstname} ${rec.lastname}'s record has been removed.`,
  //     });
  //   } catch (err) {
  //     console.error("Delete record failed:", err);
  //     setAlert({
  //       open: true,
  //       severity: "error",
  //       header: "Delete Failed",
  //       message:
  //         err.message || "Could not delete the record. Please try again.",
  //     });
  //   } finally {
  //     setDeletingRecIds((prev) => {
  //       const s = new Set(prev);
  //       s.delete(rec.recid);
  //       return s;
  //     });
  //   }
  // };
  //   const executeDelete = async (pin) => {
  //   const rec = pendingDeleteRec;
  //   setDeleteConfirmOpen(false);
  //   setPendingDeleteRec(null);
  //   setDeletingRecIds((prev) => new Set([...prev, rec.recid]));

  //   try {
  //     const result = await DeleteTransFileRecs({ recId: rec.recid });

  //     if (result?.data?.header?.callStatus !== "1") {
  //       throw new Error(result?.payload?.msg || "Delete failed");
  //     }

  //     const updatedRecords = records.filter((r) => r.recid !== rec.recid);
  //     setRecords(updatedRecords);

  //     const newTotal = updatedRecords.reduce(
  //       (sum, r) => sum + (parseFloat(r.amount) || 0),
  //       0,
  //     );
  //     const updatedCount = updatedRecords.length;
  //     const updatedNotes = selectedBatch.notes
  //       ? selectedBatch.notes.replace(
  //           /records:\s*\d+/i,
  //           `records: ${updatedCount}`,
  //         )
  //       : selectedBatch.notes;

  //     // ✅ FIX: Await the sync and check its result — don't swallow it
  //     let syncSuccess = false;
  //     try {
  //       const syncResult = await updateBatchStatus({
  //         requestid: selectedBatch.id,
  //         executionstatus: selectedBatch.rawStatus,
  //         notes: updatedNotes || "",
  //         pin: pin,
  //         requestuserid: currentUserId,
  //         amount: newTotal,
  //         uploadedby: selectedBatch.agentId,
  //         approvedby: 0,
  //         lastuserid: currentUserId,
  //         scheduletime:
  //           selectedBatch.scheduledTime !== "—"
  //             ? selectedBatch.scheduledTime
  //             : undefined,
  //       });
  //       syncSuccess = syncResult?.callStatus === "1";
  //     } catch (syncErr) {
  //       console.warn("Batch total sync failed (non-fatal):", syncErr);
  //     }

  //     // ✅ FIX: Always apply local state optimistically (don't wait for server)
  //     // This is the ground truth since we just computed it from actual records
  //     setBatches((prev) =>
  //       prev.map((b) =>
  //         b.id === selectedBatch.id
  //           ? {
  //               ...b,
  //               totalAmount: newTotal,
  //               totalAmountDisplay: newTotal.toLocaleString("en-US", {
  //                 minimumFractionDigits: 2,
  //               }),
  //               records: updatedCount,
  //               notes: updatedNotes || b.notes,
  //             }
  //           : b,
  //       ),
  //     );
  //     setSelectedBatch((prev) => ({
  //       ...prev,
  //       totalAmount: newTotal,
  //       records: updatedCount,
  //       notes: updatedNotes || prev.notes,
  //     }));

  //     // ✅ FIX: Only refresh from server if sync succeeded,
  //     // and merge server data carefully to not overwrite our computed total
  //     if (syncSuccess) {
  //       // Small delay to ensure server has committed before we re-fetch
  //       await new Promise((resolve) => setTimeout(resolve, 500));
  //       await refreshBatches();

  //       // Re-apply our computed total AFTER refresh in case server is still stale
  //       setBatches((prev) =>
  //         prev.map((b) =>
  //           b.id === selectedBatch.id
  //             ? {
  //                 ...b,
  //                 totalAmount: newTotal,
  //                 totalAmountDisplay: newTotal.toLocaleString("en-US", {
  //                   minimumFractionDigits: 2,
  //                 }),
  //                 records: updatedCount,
  //               }
  //             : b,
  //         ),
  //       );
  //     }

  //     setAlert({
  //       open: true,
  //       severity: "success",
  //       header: "Record Deleted",
  //       message: `${rec.firstname} ${rec.lastname}'s record has been removed.`,
  //     });
  //   } catch (err) {
  //     console.error("Delete record failed:", err);
  //     setAlert({
  //       open: true,
  //       severity: "error",
  //       header: "Delete Failed",
  //       message: err.message || "Could not delete the record. Please try again.",
  //     });
  //   } finally {
  //     setDeletingRecIds((prev) => {
  //       const s = new Set(prev);
  //       s.delete(rec.recid);
  //       return s;
  //     });
  //   }
  // };
  const executeDelete = async (pin) => {
    const rec = pendingDeleteRec;
    setDeleteConfirmOpen(false);
    setPendingDeleteRec(null);
    setDeletingRecIds((prev) => new Set([...prev, rec.recid]));

    try {
      const result = await DeleteTransFileRecs({ recId: rec.recid });

      if (result?.data?.header?.callStatus !== "1") {
        throw new Error(result?.payload?.msg || "Delete failed");
      }

      const updatedRecords = records.filter((r) => r.recid !== rec.recid);
      setRecords(updatedRecords);

      const newTotal = updatedRecords.reduce(
        (sum, r) => sum + (parseFloat(r.amount) || 0),
        0,
      );
      const updatedCount = updatedRecords.length;
      const updatedNotes = selectedBatch.notes
        ? selectedBatch.notes.replace(
            /records:\s*\d+/i,
            `records: ${updatedCount}`,
          )
        : selectedBatch.notes;

      // ✅ Sync batch total
      let syncSuccess = false;
      try {
        const syncResult = await updateBatchStatus({
          requestid: selectedBatch.id,
          executionstatus: selectedBatch.rawStatus,
          notes: updatedNotes || "",
          pin: pin,
          requestuserid: currentUserId,
          amount: newTotal,
          uploadedby: selectedBatch.agentId,
          approvedby: 0,
          lastuserid: currentUserId,
          scheduletime:
            selectedBatch.scheduledTime !== "—"
              ? selectedBatch.scheduledTime
              : undefined,
        });
        syncSuccess = syncResult?.callStatus === "1";
      } catch (syncErr) {
        console.warn("Batch total sync failed (non-fatal):", syncErr);
      }

      // ✅ NEW: If all records deleted, cancel the batch
      if (updatedCount === 0) {
        try {
          const cancelResult = await updateBatchStatus({
            requestid: selectedBatch.id,
            executionstatus: "4", // Cancelled
            notes: updatedNotes || "",
            pin: pin,
            requestuserid: currentUserId,
            amount: 0,
            uploadedby: selectedBatch.agentId,
            approvedby: 0,
            lastuserid: currentUserId,
            scheduletime:
              selectedBatch.scheduledTime !== "—"
                ? selectedBatch.scheduledTime
                : undefined,
          });

        if (cancelResult?.callStatus === "1") {
  setSelectedBatch(null);
  setBatches((prev) => prev.filter((b) => b.id !== selectedBatch.id));
  setCancelSnackbar({          // ✅ use dedicated snackbar instead
    open: true,
    message: `All records removed. Batch #${selectedBatch.id} has been automatically cancelled.`,
  });

  setTimeout(() => {
    refreshBatches();
  }, 1000);

  return;
}
        } catch (cancelErr) {
          console.warn("Auto-cancel failed (non-fatal):", cancelErr);
          // Fall through to regular success flow if cancel fails
        }
      }

      // Apply local state optimistically
      setBatches((prev) =>
        prev.map((b) =>
          b.id === selectedBatch.id
            ? {
                ...b,
                totalAmount: newTotal,
                totalAmountDisplay: newTotal.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                }),
                records: updatedCount,
                notes: updatedNotes || b.notes,
              }
            : b,
        ),
      );
      setSelectedBatch((prev) => ({
        ...prev,
        totalAmount: newTotal,
        records: updatedCount,
        notes: updatedNotes || prev.notes,
      }));

      if (syncSuccess) {
        await new Promise((resolve) => setTimeout(resolve, 500));
        await refreshBatches();
        setBatches((prev) =>
          prev.map((b) =>
            b.id === selectedBatch.id
              ? {
                  ...b,
                  totalAmount: newTotal,
                  totalAmountDisplay: newTotal.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                  }),
                  records: updatedCount,
                }
              : b,
          ),
        );
      }

      setAlert({
        open: true,
        severity: "success",
        header: "Record Deleted",
        message: `${rec.firstname} ${rec.lastname}'s record has been removed.`,
      });
    } catch (err) {
      console.error("Delete record failed:", err);
      setAlert({
        open: true,
        severity: "error",
        header: "Delete Failed",
        message:
          err.message || "Could not delete the record. Please try again.",
      });
    } finally {
      setDeletingRecIds((prev) => {
        const s = new Set(prev);
        s.delete(rec.recid);
        return s;
      });
    }
  };
  const requestStatusChange = (id, newStatus) => {
    const current = batches.find((b) => b.id === id)?.status;
    if (newStatus === current) return;
    setPendingAction({ id, newStatus });
    setShowPinPad(true);
  };

  // NEW - start inline edit for scheduled time
  const startEditScheduledTime = (batch) => {
    setEditingScheduledId(batch.id);
    if (batch.scheduledTime && batch.scheduledTime !== "—") {
      const [date, time] = batch.scheduledTime.split(" ");
      const timePart = time ? time.substring(0, 5) : "00:00";
      setTempScheduledValue(`${date}T${timePart}`);
    } else {
      setTempScheduledValue("");
    }
  };

  // NEW - trigger PIN prompt for scheduled time change
  const requestScheduledTimeChange = (batchId) => {
    if (!tempScheduledValue) return;
    const [date, time] = tempScheduledValue.split("T");
    const fullTime = `${date} ${time}:00`;
    setPendingScheduledChange({ batchId, newScheduledTime: fullTime });
    setShowPinPad(true);
  };

  // const handlePinConfirm = async (event, pinArray) => {
  //   console.log("selectedBatch--------------<", selectedBatch);
  //   if (
  //     (!pendingAction && !pendingScheduledChange && !pendingRecordSave) ||
  //     !Array.isArray(pinArray)
  //   ) {
  //     setShowPinPad(false);
  //     setPendingAction(null);
  //     setPendingScheduledChange(null);
  //     setPendingRecordSave(null);
  //     return;
  //   } else if (pendingDeleteRec) {
  //     const PIN = pinArray.join("");
  //     // now call the actual delete logic with PIN
  //     await executeDelete(PIN);
  //   }

  //   const PIN = pinArray.join("");
  //   // ── RECORD AMOUNT CHANGE ──
  //   if (pendingRecordSave) {
  //     const { payloadToSend, updatedRecords, newTotal } = pendingRecordSave;
  //     let isPinError = false;

  //     try {
  //       const recordResult = await UpdateTransFileRecs(payloadToSend);
  //       if (recordResult.callStatus !== "1")
  //         throw new Error("Failed to save record");
  //       const batchResult = await updateBatchStatus({
  //         requestid: selectedBatch.id,
  //         executionstatus: selectedBatch.rawStatus,
  //         notes: selectedBatch.notes || "",
  //         pin: PIN,
  //         requestuserid: currentUserId,
  //         amount: newTotal,
  //         uploadedby: selectedBatch.agentId,
  //         approvedby: 0,
  //         lastuserid: currentUserId,
  //         scheduletime:
  //           selectedBatch.scheduledTime !== "—"
  //             ? selectedBatch.scheduledTime
  //             : undefined,
  //       });

  //       if (
  //         batchResult.callStatus !== "1" &&
  //         (batchResult?.payload?.msg?.toLowerCase().includes("pin") ||
  //           batchResult?.payload?.msg?.toLowerCase().includes("invalid pin") ||
  //           batchResult?.payload?.msg?.toLowerCase().includes("incorrect pin"))
  //       ) {
  //         throw new Error(INCORRECT_PIN_ERROR);
  //       }

  //       if (batchResult.callStatus !== "1")
  //         throw new Error("Failed to sync batch total");

  //       setRecords(updatedRecords);
  //       setEditingRecId(null);

  //       setBatches((prev) =>
  //         prev.map((b) =>
  //           b.id === selectedBatch.id
  //             ? {
  //                 ...b,
  //                 totalAmount: newTotal,
  //                 totalAmountDisplay: newTotal.toLocaleString("en-US", {
  //                   minimumFractionDigits: 2,
  //                 }),
  //               }
  //             : b,
  //         ),
  //       );
  //       setSelectedBatch((prev) => ({ ...prev, totalAmount: newTotal }));
  //       setAlert({
  //         open: true,
  //         severity: "success",
  //         header: "Saved!",
  //         message: "Record and batch total updated successfully.",
  //       });
  //     } catch (error) {
  //       if (error.message === INCORRECT_PIN_ERROR) {
  //         isPinError = true;
  //         setAlert({
  //           open: true,
  //           severity: "error",
  //           header: "Incorrect PIN",
  //           message: "The PIN you entered is wrong. Please try again.",
  //         });
  //         setShowPinPad(true);
  //         return;
  //       }
  //       setAlert({
  //         open: true,
  //         severity: "error",
  //         header: "Failed",
  //         message: error.message || "Could not save record.",
  //       });
  //     } finally {
  //       if (!isPinError) {
  //         setShowPinPad(false);
  //         setPendingRecordSave(null);
  //       }
  //     }
  //     return;
  //   }

  //   // ── STATUS CHANGE ──
  //   else if (pendingAction) {
  //     const { id, newStatus } = pendingAction;
  //     const original = batches.find((b) => b.id === id);

  //     setBatches((prev) =>
  //       prev.map((b) =>
  //         b.id === id ? { ...b, status: getDisplayStatus(newStatus) } : b,
  //       ),
  //     );
  //     setSavingIds((prev) => new Set(prev).add(id));

  //     let isPinError = false;

  //     try {
  //       const result = await updateBatchStatus({
  //         requestid: id,
  //         executionstatus: newStatus,
  //         notes: "",
  //         pin: PIN,
  //         requestuserid: currentUserId,
  //         amount: original?.totalAmount || 0,
  //         uploadedby: original?.agentId,
  //         approvedby: 0,
  //         lastuserid: currentUserId,
  //       });

  //       if (
  //         result.callStatus !== "1" &&
  //         (result?.payload?.msg?.toLowerCase().includes("pin") ||
  //           result?.payload?.msg?.toLowerCase().includes("invalid pin") ||
  //           result?.payload?.msg?.toLowerCase().includes("incorrect pin") ||
  //           (result?.payload?.callStatus === "0" &&
  //             result?.payload?.msg?.includes("authentication")))
  //       ) {
  //         throw new Error(INCORRECT_PIN_ERROR);
  //       }

  //       if (result.callStatus !== "1")
  //         throw new Error("Failed to update status");

  //       if (newStatus === "-1") {
  //         const batch = batches.find((b) => b.id === id);
  //         const subject = `Payroll Batch #${id} Ready for Review`;
  //         const emailText = `PAYROLL BATCH READY FOR REVIEW\n\nBatch ID: #${id}\nFile: ${getDisplayFileName(batch.fileName)}\nRecords: ${batch.records}\nSubmitted By: ${currentUsername} (${companyName})\n\nPlease log in and review the batch at your earliest convenience.\n\n— NCS Payroll Service`;
  //         try {
  //           const emailRecipient = isDevEnv
  //             ? "no-reply@4pay.ca"
  //             : "kayon.stokes@ncsenterprises.com";
  //           await sendEmail2({
  //             destinationEmailAccount: emailRecipient,
  //             subject,
  //             emailText,
  //           });
  //         } catch (err) {
  //           console.warn("Email failed (non-blocking):", err);
  //         }
  //       }

  //       await refreshBatches();
  //       setAlert({
  //         open: true,
  //         severity: "success",
  //         header: "Success",
  //         message: `Batch #${id} → ${getDisplayStatus(newStatus)}${newStatus === "-1" ? " — Email sent!" : ""}`,
  //       });
  //     } catch (error) {
  //       if (error.message === INCORRECT_PIN_ERROR) {
  //         isPinError = true;
  //         setAlert({
  //           open: true,
  //           severity: "error",
  //           header: "Incorrect PIN",
  //           message: "The PIN you entered is wrong. Please try again.",
  //         });
  //         setBatches((prev) => prev.map((b) => (b.id === id ? original : b)));
  //         setShowPinPad(true);
  //         return;
  //       }
  //       setAlert({
  //         open: true,
  //         severity: "error",
  //         header: "Failed",
  //         message: "Status update failed.",
  //       });
  //       setBatches((prev) => prev.map((b) => (b.id === id ? original : b)));
  //     } finally {
  //       setSavingIds((prev) => {
  //         const s = new Set(prev);
  //         s.delete(id);
  //         return s;
  //       });
  //       if (!isPinError) {
  //         setShowPinPad(false);
  //         setPendingAction(null);
  //       }
  //     }
  //   }

  //   // ── SCHEDULED TIME CHANGE ──
  //   else if (pendingScheduledChange) {
  //     const { batchId, newScheduledTime } = pendingScheduledChange;
  //     const batch = batches.find((b) => b.id === batchId);
  //     if (!batch) return;

  //     setSavingIds((prev) => new Set([...prev, batchId]));
  //     let isPinError = false;

  //     try {
  //       const result = await updateBatchStatus({
  //         requestid: batchId,
  //         executionstatus: batch.rawStatus,
  //         notes: "",
  //         pin: PIN,
  //         requestuserid: currentUserId,
  //         amount: batch.totalAmount || 0,
  //         uploadedby: batch?.agentId,
  //         approvedby: 0,
  //         lastuserid: currentUserId,
  //         scheduletime: newScheduledTime,
  //       });

  //       if (
  //         result.callStatus !== "1" &&
  //         (result?.payload?.msg?.toLowerCase().includes("pin") ||
  //           result?.payload?.msg?.toLowerCase().includes("invalid pin") ||
  //           result?.payload?.msg?.toLowerCase().includes("incorrect pin") ||
  //           (result?.payload?.callStatus === "0" &&
  //             result?.payload?.msg?.includes("authentication")))
  //       ) {
  //         throw new Error(INCORRECT_PIN_ERROR);
  //       }

  //       if (result.callStatus !== "1")
  //         throw new Error("Failed to update scheduled time");

  //       await refreshBatches();
  //       setAlert({
  //         open: true,
  //         severity: "success",
  //         header: "Success",
  //         message: `Scheduled time for batch #${batchId} updated`,
  //       });
  //       setEditingScheduledId(null);
  //       setTempScheduledValue("");
  //     } catch (error) {
  //       if (error.message === INCORRECT_PIN_ERROR) {
  //         isPinError = true;
  //         setAlert({
  //           open: true,
  //           severity: "error",
  //           header: "Incorrect PIN",
  //           message: "The PIN you entered is wrong. Please try again.",
  //         });
  //         setShowPinPad(true);
  //         return;
  //       }
  //       setAlert({
  //         open: true,
  //         severity: "error",
  //         header: "Failed",
  //         message: "Could not update scheduled time.",
  //       });
  //     } finally {
  //       setSavingIds((prev) => {
  //         const s = new Set(prev);
  //         s.delete(batchId);
  //         return s;
  //       });
  //       if (!isPinError) {
  //         setShowPinPad(false);
  //         setPendingScheduledChange(null);
  //       }
  //     }
  //   }
  // };
  const handlePinConfirm = async (event, pinArray) => {
     if (isSubmittingRef.current) {
    console.warn("handlePinConfirm already in progress — ignoring duplicate call");
    return;
  }
  isSubmittingRef.current = true;
  setPinProcessing(true);
    try {
       if (!Array.isArray(pinArray)) {
      setShowPinPad(false);
      setPendingAction(null);
      setPendingScheduledChange(null);
      setPendingRecordSave(null);
      return;
    }

    const PIN = pinArray.join("");

    // ── DELETE RECORD ──
    if (pendingDeleteRec) {
      await executeDelete(PIN);
      setShowPinPad(false);
      return; // ← stops falling through to other blocks
    }

    // ── RECORD AMOUNT CHANGE ──
    if (pendingRecordSave) {
      const { payloadToSend, updatedRecords, newTotal } = pendingRecordSave;
      let isPinError = false;

      try {
        const recordResult = await UpdateTransFileRecs(payloadToSend);
        if (recordResult.callStatus !== "1")
          throw new Error("Failed to save record");

        const batchResult = await updateBatchStatus({
          requestid: selectedBatch.id,
          executionstatus: selectedBatch.rawStatus,
          notes: selectedBatch.notes || "",
          pin: PIN,
          requestuserid: currentUserId,
          amount: newTotal,
          uploadedby: selectedBatch.agentId,
          approvedby: 0,
          lastuserid: currentUserId,
          scheduletime:
            selectedBatch.scheduledTime !== "—"
              ? selectedBatch.scheduledTime
              : undefined,
        });

        if (
          batchResult.callStatus !== "1" &&
          (batchResult?.payload?.msg?.toLowerCase().includes("pin") ||
            batchResult?.payload?.msg?.toLowerCase().includes("invalid pin") ||
            batchResult?.payload?.msg?.toLowerCase().includes("incorrect pin"))
        ) {
          throw new Error(INCORRECT_PIN_ERROR);
        }

        if (batchResult.callStatus !== "1")
          throw new Error("Failed to sync batch total");

        setRecords(updatedRecords);
        setEditingRecId(null);
        setBatches((prev) =>
          prev.map((b) =>
            b.id === selectedBatch.id
              ? {
                  ...b,
                  totalAmount: newTotal,
                  totalAmountDisplay: newTotal.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                  }),
                }
              : b,
          ),
        );
        setSelectedBatch((prev) => ({ ...prev, totalAmount: newTotal }));
        setAlert({
          open: true,
          severity: "success",
          header: "Saved!",
          message: "Record and batch total updated successfully.",
        });
      } catch (error) {
        if (error.message === INCORRECT_PIN_ERROR) {
          isPinError = true;
          setAlert({
            open: true,
            severity: "error",
            header: "Incorrect PIN",
            message: "The PIN you entered is wrong. Please try again.",
          });
          setShowPinPad(true);
          return;
        }
        setAlert({
          open: true,
          severity: "error",
          header: "Failed",
          message: error.message || "Could not save record.",
        });
      } finally {
        if (!isPinError) {
          setShowPinPad(false);
          setPendingRecordSave(null);
        }
      }
      return;
    }

    // ── STATUS CHANGE ──
    if (pendingAction) {
      const { id, newStatus } = pendingAction;
      const original = batches.find((b) => b.id === id);

      setBatches((prev) =>
        prev.map((b) =>
          b.id === id ? { ...b, status: getDisplayStatus(newStatus) } : b,
        ),
      );
      setSavingIds((prev) => new Set(prev).add(id));

      let isPinError = false;

      try {
        const result = await updateBatchStatus({
          requestid: id,
          executionstatus: newStatus,
          notes: "",
          pin: PIN,
          requestuserid: currentUserId,
          amount: original?.totalAmount || 0,
          uploadedby: original?.agentId,
          approvedby: 0,
          lastuserid: currentUserId,
        });

        if (
          result.callStatus !== "1" &&
          (result?.payload?.msg?.toLowerCase().includes("pin") ||
            result?.payload?.msg?.toLowerCase().includes("invalid pin") ||
            result?.payload?.msg?.toLowerCase().includes("incorrect pin") ||
            (result?.payload?.callStatus === "0" &&
              result?.payload?.msg?.includes("authentication")))
        ) {
          throw new Error(INCORRECT_PIN_ERROR);
        }

        if (result.callStatus !== "1")
          throw new Error("Failed to update status");

        if (newStatus === "-1") {
          const batch = batches.find((b) => b.id === id);
          const subject = `Payroll Batch #${id} Ready for Review`;
          const emailText = `PAYROLL BATCH READY FOR REVIEW\n\nBatch ID: #${id}\nFile: ${getDisplayFileName(batch.fileName)}\nRecords: ${batch.records}\nSubmitted By: ${currentUsername} (${companyName})\n\nPlease log in and review the batch at your earliest convenience.\n\n— NCS Payroll Service`;
          try {
            const emailRecipient = isDevEnv
              ? "no-reply@4pay.ca"
              : "kayon.stokes@ncsenterprises.com";
            await sendEmail2({
              destinationEmailAccount: emailRecipient,
              subject,
              emailText,
            });
          } catch (err) {
            console.warn("Email failed (non-blocking):", err);
          }
        }

        await refreshBatches();
        setAlert({
          open: true,
          severity: "success",
          header: "Success",
          message: `Batch #${id} → ${getDisplayStatus(newStatus)}${newStatus === "-1" ? " — Email sent!" : ""}`,
        });
      } catch (error) {
        if (error.message === INCORRECT_PIN_ERROR) {
          isPinError = true;
          setAlert({
            open: true,
            severity: "error",
            header: "Incorrect PIN",
            message: "The PIN you entered is wrong. Please try again.",
          });
          setBatches((prev) => prev.map((b) => (b.id === id ? original : b)));
          setShowPinPad(true);
          return;
        }
        setAlert({
          open: true,
          severity: "error",
          header: "Failed",
          message: "Status update failed.",
        });
        setBatches((prev) => prev.map((b) => (b.id === id ? original : b)));
      } finally {
        setSavingIds((prev) => {
          const s = new Set(prev);
          s.delete(id);
          return s;
        });
        if (!isPinError) {
          setShowPinPad(false);
          setPendingAction(null);
        }
      }
      return;
    }

    // ── SCHEDULED TIME CHANGE ──
    if (pendingScheduledChange) {
      const { batchId, newScheduledTime } = pendingScheduledChange;
      const batch = batches.find((b) => b.id === batchId);
      if (!batch) return;

      setSavingIds((prev) => new Set([...prev, batchId]));
      let isPinError = false;

      try {
        const result = await updateBatchStatus({
          requestid: batchId,
          executionstatus: batch.rawStatus,
          notes: "",
          pin: PIN,
          requestuserid: currentUserId,
          amount: batch.totalAmount || 0,
          uploadedby: batch?.agentId,
          approvedby: 0,
          lastuserid: currentUserId,
          scheduletime: newScheduledTime,
        });

        if (
          result.callStatus !== "1" &&
          (result?.payload?.msg?.toLowerCase().includes("pin") ||
            result?.payload?.msg?.toLowerCase().includes("invalid pin") ||
            result?.payload?.msg?.toLowerCase().includes("incorrect pin") ||
            (result?.payload?.callStatus === "0" &&
              result?.payload?.msg?.includes("authentication")))
        ) {
          throw new Error(INCORRECT_PIN_ERROR);
        }

        if (result.callStatus !== "1")
          throw new Error("Failed to update scheduled time");

        await refreshBatches();
        setAlert({
          open: true,
          severity: "success",
          header: "Success",
          message: `Scheduled time for batch #${batchId} updated`,
        });
        setEditingScheduledId(null);
        setTempScheduledValue("");
      } catch (error) {
        if (error.message === INCORRECT_PIN_ERROR) {
          isPinError = true;
          setAlert({
            open: true,
            severity: "error",
            header: "Incorrect PIN",
            message: "The PIN you entered is wrong. Please try again.",
          });
          setShowPinPad(true);
          return;
        }
        setAlert({
          open: true,
          severity: "error",
          header: "Failed",
          message: "Could not update scheduled time.",
        });
      } finally {
        setSavingIds((prev) => {
          const s = new Set(prev);
          s.delete(batchId);
          return s;
        });
        if (!isPinError) {
          setShowPinPad(false);
          setPendingScheduledChange(null);
        }
      }
    }
    } catch (error) {
      
    } finally {
      isSubmittingRef.current = false;
      setPinProcessing(false);
    }
   
  };
  const getStatusColor = (status) =>
    ({
      Open: "#e2e3e5",
      "Review in Progress": "#fff3cd",
      "Approved for Processing": "#d4edda",
      Rejected: "#f8d7da",
      Completed: "#d1ecf1",
      Error: "#f5c6cb",
      Cancelled: "#d6d8db",
    })[status] || "#f8f9fa";

  const getStatusTextColor = (status) =>
    ({
      Open: "#383d41",
      "Review in Progress": "#856404",
      "Approved for Processing": "#155724",
      Rejected: "#721c24",
      Completed: "#0c5460",
      Error: "#721c24",
      Cancelled: "#495057",
    })[status] || "#333";

  const handleDownloadCSV = async (batchId, fileName) => {
    try {
      const res = await ListTransFileRecs(batchId);

      if (res.callStatus !== "1") {
        setAlert({
          open: true,
          severity: "error",
          header: "Download Failed",
          message: "Could not load records for download.",
        });
        return;
      }

      const rawArray = res.payload?.record || [];
      const recordsArray = Array.isArray(rawArray)
        ? rawArray
        : rawArray
          ? [rawArray]
          : [];
      const allRecords = recordsArray
        .map((item) => item.Transfilerecs)
        .filter(Boolean);

      if (allRecords.length === 0) {
        setAlert({
          open: true,
          severity: "info",
          header: "No Data",
          message: "No records to download.",
        });
        return;
      }

      const headers = [
        "First Name",
        "Last Name",
        "Email",
        "Phone",
        "Amount",
        "Currency",
        "Address Line 1",
        "Address Line 2",
        "Country",
        "State",
        "Zip Code",
        "Date of Birth",
        "Comment",
        "Purpose of Account",
      ];

      const rows = allRecords.map((r) => [
        r.firstname || "",
        r.lastname || "",
        r.email || "",
        r.phoneno || "",
        r.amount || "",
        r.currency || "",
        r.address1 || "",
        r.address2 || "",
        r.country || "",
        r.state || "",
        r.zipcode || "",
        r.birthdate || "",
        decodeHtmlEntities(r.comment) || "",
        r.purposeofaccount || "",
      ]);

      const csv = [
        headers.join(","),
        ...rows.map((row) => row.map((cell) => `"${cell}"`).join(",")),
      ].join("\n");

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `${getDisplayFileName(fileName).replace(".csv", "")}_records.csv`,
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Download failed:", err);
      setAlert({
        open: true,
        severity: "error",
        header: "Download Failed",
        message: "Error generating CSV file.",
      });
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
        <CircularProgress size={48} />
      </Box>
    );
  }
  const getDisplayFileName = (fileName) => {
    if (!fileName) return "—";
    const fixedFileName = fileName.replace(/BATCH_-/i, "BATCH-");
    const regexPattern = companyName
      .replace(/[^a-zA-Z0-9'\s]/g, "_+")
      .replace(/'/g, "_")
      .replace(/\s+/g, "_+");

    const displayCompany = companyName
      .replace(/[^a-zA-Z0-9'\s]/g, "_")
      .replace(/\s+/g, "_");

    try {
      const regex = new RegExp(regexPattern, "i");
      const restored = fixedFileName.replace(regex, displayCompany);
      return cleanFileName(restored);
    } catch (e) {
      return cleanFileName(fixedFileName);
    }
  };
  return (
    <div className="review-payroll-container">
      <div className="review-header">
        <h2>Payroll Batch Management </h2>
        <p>Review, edit individual records</p>
      </div>

      <div className="review-table-wrapper">
        {batches.length === 0 ? (
          <Box sx={{ textAlign: "center", py: 8, color: "#666" }}>
            No payroll batches found.
          </Box>
        ) : (
          <table className="review-table">
            <thead>
              <tr>
                <th>Batch ID</th>
                <th>Agent ID</th>
                <th>File</th>
                <th>Total Amount</th>
                <th>Uploaded</th>
                <th>Scheduled Time</th>
                <th>Notes</th>
                <th>Actions</th>
                <th>Status</th>
                <th>Uploaded By</th>
                <th>Approved By</th>
                <th>Rejected By</th>
              </tr>
            </thead>
            <tbody>
              {batches.map((batch) => (
                <tr key={batch.id}>
                  <td>
                    <strong>{batch.id}</strong>
                  </td>
                  <td>{batch.agentId}</td>
                  <td>
                    {" "}
                    <code>{getDisplayFileName(batch.fileName)}</code>
                  </td>
                  <td
                    style={{
                      textAlign: "right",
                      fontWeight: "500",
                      color: "#1976d2",
                    }}
                  >
                    {batch.totalAmountDisplay}
                  </td>
                  <td>{batch.uploadedAt}</td>

                  <td>
                    {editingScheduledId === batch.id ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <TextField
                          type="datetime-local"
                          size="small"
                          value={tempScheduledValue}
                          onChange={(e) =>
                            setTempScheduledValue(e.target.value)
                          }
                          InputLabelProps={{ shrink: true }}
                          sx={{ width: 180 }}
                        />
                        <IconButton
                          size="small"
                          color="success"
                          onClick={() => requestScheduledTimeChange(batch.id)}
                        >
                          <CheckIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => {
                            setEditingScheduledId(null);
                            setTempScheduledValue("");
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        {batch.scheduledTime}
                        {(batch.rawStatus === "-2" ||
                          batch.rawStatus === "5") && (
                          <Tooltip title="Edit scheduled time">
                            <IconButton
                              size="small"
                              onClick={() => startEditScheduledTime(batch)}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </div>
                    )}
                  </td>

                  <td style={{ fontSize: "0.85rem", maxWidth: "340px" }}>
                    {batch.notes}
                  </td>
                  <td>
                    <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => openRecordEditor(batch)}
                        sx={{ mr: 1, backgroundColor: "#5523D2" }}
                      >
                        {batch.status === "Open" || batch.status === "Rejected"
                          ? "Edit Records"
                          : "View Records"}
                      </Button>

                      <Tooltip title="Download CSV">
                        <IconButton
                          size="small"
                          onClick={() =>
                            handleDownloadCSV(batch.id, batch.fileName)
                          }
                          sx={{ color: "#145388" }}
                        >
                          <DownloadIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </td>

                  <td>
                    {savingIds.has(batch.id) ? (
                      <CircularProgress size={20} />
                    ) : batch.rawStatus === "-1" || batch.rawStatus === "4" ? (
                      <span style={{ fontWeight: "bold", color: "#856404" }}>
                        {batch.status}
                      </span>
                    ) : (
                      <select
                        value={batch.rawStatus}
                        onChange={(e) =>
                          requestStatusChange(batch.id, e.target.value)
                        }
                        className="status-select"
                      >
                        <option value={batch.rawStatus} disabled hidden>
                          {batch.status}
                        </option>

                        {batch.rawStatus !== "-2" &&
                          batch.rawStatus !== "-1" &&
                          batch.rawStatus !== "5" && (
                            <option value="-2">Open</option>
                          )}

                        {batch.rawStatus !== "-1" && (
                          <option value="-1">Send for NCS Approval</option>
                        )}

                        {batch.rawStatus !== "-1" &&
                          batch.rawStatus !== "0" &&
                          batch.rawStatus !== "3" &&
                          batch.rawStatus !== "4" &&
                          batch.rawStatus !== "2" && (
                            <option value="4">Cancel</option>
                          )}
                      </select>
                    )}
                  </td>
                  <td>
                    {userNames[batch.uploadedby] || batch.uploadedby || "—"}
                  </td>
                  <td>
                    {userNames[batch.approvedby] || batch.approvedby || "—"}
                  </td>
                  <td>
                    {userNames[batch.rejectedby] || batch.rejectedby || "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* EDIT MODAL (only for editable batches) */}
      <Modal
        open={
          !!selectedBatch &&
          (selectedBatch.status === "Open" ||
            selectedBatch.status === "Rejected")
        }
        onClose={() => setSelectedBatch(null)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "95%",
            maxWidth: 1650,
            maxHeight: "90vh",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            overflow: "auto",
          }}
        >
          {selectedBatch && (
            <>
              <Typography variant="h5" gutterBottom>
                Editing Batch #{selectedBatch.id} —{" "}
                {getDisplayFileName(selectedBatch.fileName)}
              </Typography>

              <Typography variant="body1" sx={{ mb: 3 }}>
                <strong>{records.length}</strong> record
                {records.length !== 1 && "s"} • Click Edit to modify or Delete
                to remove a row
              </Typography>

              {recordsLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    py: 8,
                  }}
                >
                  <CircularProgress size={48} />
                  <Typography sx={{ ml: 2, color: "#666" }}>
                    Loading records...
                  </Typography>
                </Box>
              ) : records.length === 0 ? (
                <Box sx={{ textAlign: "center", py: 8, color: "#999" }}>
                  No records found in this batch.
                </Box>
              ) : (
                <div style={{ overflowX: "auto" }}>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "0.9rem",
                    }}
                  >
                    <thead>
                      <tr style={{ background: "#5523D2", color: "white" }}>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          First Name
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Last Name
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Email
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Phone
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Amount
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Currency
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Address
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Country
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          DOB
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Account No
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Comment
                        </th>
                        <th style={{ padding: "12px", textAlign: "center" }}>
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {records.map((rec) => (
                        <tr
                          key={rec.id}
                          style={{ borderBottom: "1px solid #eee" }}
                        >
                          {editingRecId === rec.id ? (
                            // ── EDITABLE ROW ──
                            <>
                              <td style={{ padding: "10px" }}>
                                <TextField
                                  size="small"
                                  value={editForm.firstname || ""}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      firstname: e.target.value,
                                    })
                                  }
                                  fullWidth
                                />
                              </td>
                              <td style={{ padding: "10px" }}>
                                <TextField
                                  size="small"
                                  value={editForm.lastname || ""}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      lastname: e.target.value,
                                    })
                                  }
                                  fullWidth
                                />
                              </td>
                              <td style={{ padding: "10px" }}>
                                <TextField
                                  size="small"
                                  value={editForm.email || ""}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      email: e.target.value,
                                    })
                                  }
                                  fullWidth
                                />
                              </td>
                              <td style={{ padding: "10px" }}>
                                <TextField
                                  size="small"
                                  value={editForm.phoneno || ""}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      phoneno: e.target.value,
                                    })
                                  }
                                  fullWidth
                                />
                              </td>
                              <td style={{ padding: "10px" }}>
                                <TextField
                                  size="small"
                                  type="number"
                                  step="0.01"
                                  value={editForm.amount || ""}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      amount: e.target.value,
                                    })
                                  }
                                  fullWidth
                                />
                              </td>
                              <td style={{ padding: "10px" }}>
                                <Select
                                  size="small"
                                  value={editForm.currency || "CAD"}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      currency: e.target.value,
                                    })
                                  }
                                  fullWidth
                                >
                                  <MenuItem value="CAD">CAD</MenuItem>
                                  <MenuItem value="USD">USD</MenuItem>
                                  <MenuItem value="EUR">EUR</MenuItem>
                                </Select>
                              </td>
                              <td style={{ padding: "10px" }}>
  <TextField
    size="small"
    value={editForm.addressCombined ?? ""}
    onChange={(e) =>
      setEditForm({ ...editForm, addressCombined: e.target.value })
    }
    placeholder="Full address"
    fullWidth
  />
</td>
                              <td style={{ padding: "10px" }}>
                                <TextField
                                  size="small"
                                  value={editForm.country || ""}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      country: e.target.value,
                                    })
                                  }
                                  fullWidth
                                />
                              </td>
                              <td style={{ padding: "10px" }}>
                                <TextField
                                  size="small"
                                  type="date"
                                  value={editForm.birthdate || ""}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      birthdate: e.target.value,
                                    })
                                  }
                                  fullWidth
                                />
                              </td>
                              <td style={{ padding: "10px" }}>
                                <TextField
                                  size="small"
                                  value={editForm.accountno || "0"}
                                  InputProps={{ readOnly: true }}
                                  fullWidth
                                />
                              </td>
                              <td style={{ padding: "10px" }}>
                                <TextField
                                  size="small"
                                  value={editForm.comment || ""}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      comment: e.target.value,
                                    })
                                  }
                                  fullWidth
                                />
                              </td>
                              <td
                                style={{ padding: "10px", textAlign: "center" }}
                              >
                                <Button
                                  size="small"
                                  variant="contained"
                                  color="success"
                                  onClick={saveRecord}
                                >
                                  Save
                                </Button>
                                <Button
                                  size="small"
                                  onClick={() => setEditingRecId(null)}
                                  sx={{ ml: 1 }}
                                >
                                  Cancel
                                </Button>
                              </td>
                            </>
                          ) : (
                            // ── VIEW ROW (inside edit modal) ──
                            <>
                              <td style={{ padding: "10px" }}>
                                {rec.firstname || "—"}
                              </td>
                              <td style={{ padding: "10px" }}>
                                {rec.lastname || "—"}
                              </td>
                              <td style={{ padding: "10px" }}>
                                {rec.email || "—"}
                              </td>
                              <td style={{ padding: "10px" }}>
                                {rec.phoneno || "—"}
                              </td>
                              <td
                                style={{ padding: "10px", fontWeight: "bold" }}
                              >
                                {rec.amount} {rec.currency}
                              </td>
                              <td style={{ padding: "10px" }}>
                                {rec.currency || "—"}
                              </td>
                              <td style={{ padding: "10px" }}>
                                {rec.address1} {rec.address2}
                              </td>
                              <td style={{ padding: "10px" }}>
                                {rec.country || "—"}
                              </td>
                              <td style={{ padding: "10px" }}>
                                {rec.birthdate || "—"}
                              </td>
                              <td style={{ padding: "10px" }}>
                                {rec.accountno || "0"}
                              </td>
                              <td
                                style={{
                                  padding: "10px",
                                  maxWidth: "200px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                title={rec.comment}
                              >
                                {cleanComment(rec.comment)}
                              </td>
                              <td
                                style={{
                                  padding: "10px",
                                  textAlign: "center",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <Button
                                  size="small"
                                  variant="outlined"
                                  onClick={() => startEdit(rec)}
                                  disabled={deletingRecIds.has(rec.recid)}
                                >
                                  Edit
                                </Button>

                                {/* ── DELETE BUTTON ── */}
                                <Tooltip title="Delete this record">
                                  <span>
                                    <IconButton
                                      size="small"
                                      color="error"
                                      sx={{ ml: 1 }}
                                      onClick={() => promptDeleteRecord(rec)}
                                      disabled={deletingRecIds.has(rec.recid)}
                                    >
                                      {deletingRecIds.has(rec.recid) ? (
                                        <CircularProgress
                                          size={16}
                                          color="error"
                                        />
                                      ) : (
                                        <DeleteIcon fontSize="small" />
                                      )}
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              </td>
                            </>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* TOTAL AMOUNT SECTION */}
                  <Box
                    sx={{
                      mt: 3,
                      p: 3,
                      backgroundColor: "#f0f4ff",
                      borderRadius: 2,
                      border: "1px solid #c5d4ff",
                      textAlign: "right",
                    }}
                  >
                    <Typography variant="h6" fontWeight="bold" color="#1a237e">
                      Total Amount
                    </Typography>

                    {isSingleCurrency ? (
                      <Typography
                        variant="h4"
                        fontWeight="bold"
                        color="#1976d2"
                        sx={{ mt: 1 }}
                      >
                        {grandTotal.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}{" "}
                        {mainCurrency}
                      </Typography>
                    ) : (
                      <>
                        {Object.entries(totalsByCurrency).map(
                          ([curr, total]) => (
                            <Typography
                              key={curr}
                              variant="h6"
                              sx={{ mt: 0.5 }}
                            >
                              {total.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}{" "}
                              {curr}
                            </Typography>
                          ),
                        )}
                      </>
                    )}
                  </Box>
                </div>
              )}

              <Box sx={{ mt: 4, textAlign: "right" }}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => setSelectedBatch(null)}
                >
                  Close
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Modal>

      {/* VIEW-ONLY MODAL (for non-editable statuses) */}
      <Modal
        open={
          !!selectedBatch &&
          selectedBatch.status !== "Open" &&
          selectedBatch.status !== "Rejected"
        }
        onClose={() => setSelectedBatch(null)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "95%",
            maxWidth: 1650,
            maxHeight: "90vh",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            overflow: "auto",
          }}
        >
          {selectedBatch && (
            <>
              <Typography variant="h5" gutterBottom>
                Viewing Batch #{selectedBatch.id} —{" "}
                {getDisplayFileName(selectedBatch.fileName)}
              </Typography>

              <Typography
                variant="body1"
                sx={{ mb: 3, color: "#856404", fontWeight: "bold" }}
              >
                View-only mode (Status: {selectedBatch.status}) — Editing is not
                allowed.
              </Typography>

              {recordsLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    py: 8,
                  }}
                >
                  <CircularProgress size={48} />
                  <Typography sx={{ ml: 2, color: "#666" }}>
                    Loading records...
                  </Typography>
                </Box>
              ) : records.length === 0 ? (
                <Box sx={{ textAlign: "center", py: 8, color: "#999" }}>
                  No records found in this batch.
                </Box>
              ) : (
                <div style={{ overflowX: "auto" }}>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "0.9rem",
                    }}
                  >
                    <thead>
                      <tr style={{ background: "#5523D2", color: "white" }}>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          First Name
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Last Name
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Email
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Phone
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Amount
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Currency
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Address
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Country
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          DOB
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Account No
                        </th>
                        <th style={{ padding: "12px", textAlign: "left" }}>
                          Comment
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {records.map((rec) => (
                        <tr
                          key={rec.id}
                          style={{ borderBottom: "1px solid #eee" }}
                        >
                          <td style={{ padding: "10px" }}>
                            {rec.firstname || "—"}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {rec.lastname || "—"}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {rec.email || "—"}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {rec.phoneno || "—"}
                          </td>
                          <td style={{ padding: "10px", fontWeight: "bold" }}>
                            {rec.amount} {rec.currency}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {rec.currency || "—"}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {rec.address1} {rec.address2}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {rec.country || "—"}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {rec.birthdate || "—"}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {rec.accountno || "0"}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              maxWidth: "200px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                            title={rec.comment}
                          >
                            {rec.comment || "—"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* TOTAL AMOUNT SECTION */}
                  <Box
                    sx={{
                      mt: 3,
                      p: 3,
                      backgroundColor: "#f0f4ff",
                      borderRadius: 2,
                      border: "1px solid #c5d4ff",
                      textAlign: "right",
                    }}
                  >
                    <Typography variant="h6" fontWeight="bold" color="#1a237e">
                      Total Amount
                    </Typography>

                    {isSingleCurrency ? (
                      <Typography
                        variant="h4"
                        fontWeight="bold"
                        color="#1976d2"
                        sx={{ mt: 1 }}
                      >
                        {grandTotal.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}{" "}
                        {mainCurrency}
                      </Typography>
                    ) : (
                      <>
                        {Object.entries(totalsByCurrency).map(
                          ([curr, total]) => (
                            <Typography
                              key={curr}
                              variant="h6"
                              sx={{ mt: 0.5 }}
                            >
                              {total.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}{" "}
                              {curr}
                            </Typography>
                          ),
                        )}
                      </>
                    )}
                  </Box>
                </div>
              )}

              <Box sx={{ mt: 4, textAlign: "right" }}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => setSelectedBatch(null)}
                >
                  Close
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Modal>

      {/* ── DELETE CONFIRMATION DIALOG ─────────────────────────────────────── */}
      <Dialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ color: "#c62828", fontWeight: "bold" }}>
          Delete Record?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {pendingDeleteRec ? (
              <>
                You are about to permanently remove the record for{" "}
                <strong>
                  {pendingDeleteRec.firstname} {pendingDeleteRec.lastname}
                </strong>{" "}
                ({pendingDeleteRec.email || "no email"}) from this batch.
                <br />
                <br />
                This action <strong>cannot be undone</strong>. The batch total
                will be updated automatically.
              </>
            ) : (
              "Are you sure you want to delete this record?"
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => {
              setDeleteConfirmOpen(false);
              setPendingDeleteRec(null);
            }}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setDeleteConfirmOpen(false);
              setShowPinPad(true); // ← show PIN pad after confirmation
            }}
          >
            Delete Record
          </Button>
        </DialogActions>
      </Dialog>
      {/* ─────────────────────────────────────────────────────────────────────── */}

      {/* PIN PAD */}
      {showPinPad && (
        <PinPad
          show={showPinPad}
          handleConfirm={handlePinConfirm}
          onClick={() => {
            setShowPinPad(false);
            setPendingAction(null);
            setPendingScheduledChange(null);
            setPendingRecordSave(null);
          }}
          loading={pinProcessing}
        />
      )}

      <CustomAlert
        severity={alert.severity}
        show={alert.open}
        header={alert.header}
        message={alert.message}
        onClick={() => setAlert({ ...alert, open: false })}
        autoclose={alert.severity === "success"}
      />
      <Snackbar
  open={cancelSnackbar.open}
  autoHideDuration={5000}
  onClose={() => setCancelSnackbar({ open: false, message: "" })}
  anchorOrigin={{ vertical: "top", horizontal: "center" }}
>
  <Alert
    onClose={() => setCancelSnackbar({ open: false, message: "" })}
    severity="warning"
    variant="filled"
    icon={false}
    sx={{
      backgroundColor: "#fff8e1",
      color: "#5d4037",
      border: "1px solid #ffe082",
      borderRadius: 2,
      fontSize: "1rem",
      fontWeight: 500,
      minWidth: 360,
      boxShadow: 3,
      "& .MuiAlert-message": { width: "100%" },
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
      <span style={{ fontSize: "1.4rem" }}>🚫</span>
      <Box>
        <Typography fontWeight="bold" fontSize="1rem" color="#4e342e">
          Batch Cancelled
        </Typography>
        <Typography fontSize="0.9rem" color="#5d4037">
          {cancelSnackbar.message}
        </Typography>
      </Box>
    </Box>
  </Alert>
</Snackbar>
    </div>
  );
}
